import {observable, action} from 'mobx';
import base from '../../tool/base';

export class MainStore {

  constructor(routing) {
    this.routing = routing;
  }

  @observable visibleNav = false;
  @observable modeList = [];
  @observable devList = [];
  @observable nStandardList = [];
  @observable modeCount = 0;
  @observable devCount = 0;
  @observable nStandardCount = 0;
  @observable visibleApply = false;
  @observable appDetail = {};
  @observable applyType = '';
  @observable mainCount = 0;
  @observable modulesList = {};

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  }
  @action
  clear = () => {
    this.modeList = [];
    this.devList = [];
    this.nStandardList = [];
    this.modeCount = 0;
    this.devCount = 0;
    this.nStandardCount = 0;
  }
  @action
  init = () => {
    this.appDetail = {};
    this.applyType = '';
    this.visibleApply = false;
  }
}


// WEBPACK FOOTER //
// ./src/stores/main/MainStore.js